module.exports = __webpack_public_path__ + "static/img/magnoFxBanner.4193611.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/magnoFxBanner.jpg
// module id = oNXs
// module chunks = 4